// extracted by mini-css-extract-plugin
export var label = "_e1-5";
export var slideContainer = "_e1-0";
export var slider = "_e1-1";
export var sliderLg = "_e1-4";
export var sliderMd = "_e1-3";
export var sliderSm = "_e1-2";